import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const avatarRoot = style({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  height: "32px",
  width: "32px",
  borderRadius: "100px"
});

export const avatarImage = style({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "inherit"
});

export const avatarFallback = style({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: primitiveTokens.type.sm,
  lineHeight: "normal",
  fontWeight: 600,
  borderRadius: "100px",
  backgroundColor: semanticThemeTokens.avatar.backgroundColor,
  color: semanticThemeTokens.avatar.color
});
